import { useGetResources } from '@hooks/useGetResources';
import { useAppDispatch } from '@store';
import { showRemoveAktivitetConfirmation } from '@store/verktoy/slice/verktoySlice';
import { getDeleteButtonText } from '@utils/utils';
import { shouldShowDeleteButton } from '@utils/verktoyContainer-utils';
import { useLocation } from 'react-router';

import type { Verktoy } from '@src/types/minhelseentities';

import Button, { type ButtonVariant } from '@helsenorge/designsystem-react/components/Button';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import X from '@helsenorge/designsystem-react/components/Icons/X';

interface Props {
  verktoy: Verktoy;
  erLaeringsaktivitet: boolean;
  className?: string;
  variant?: ButtonVariant;
}

const DeleteVerktoyElement = ({ verktoy, erLaeringsaktivitet, className, variant }: Props): React.JSX.Element => {
  const location = useLocation();
  const enteredDetailsPageFrom = location.state?.from || '';
  const resources = useGetResources();
  const dispatch = useAppDispatch();

  const kanVise = shouldShowDeleteButton(erLaeringsaktivitet, enteredDetailsPageFrom);
  if (kanVise) {
    return (
      <Button
        className={className}
        testId={`deleteVerktoyButton-${verktoy.Navn}`}
        variant={variant || 'borderless'}
        concept="destructive"
        onClick={(): void => {
          dispatch(showRemoveAktivitetConfirmation({ verktoy }));
        }}
      >
        {getDeleteButtonText(verktoy, resources)}
        <Icon svgIcon={X} />
      </Button>
    );
  } else {
    return <></>;
  }
};

export default DeleteVerktoyElement;
